<template>
  <md-table-row>
    <md-table-cell>
      <label>{{ group.name }}</label>
    </md-table-cell>
    <md-table-cell>
      <label>{{group.payment_method ? group.payment_method.label : null}}</label>
    </md-table-cell>
    <md-table-cell>
      <label v-if="group.payment_method && group.payment_method.card">
        クレジットカード
      </label>
      <label v-else>銀⾏振込</label>
    </md-table-cell>
    <md-table-cell>
      <label>{{ group.payment_method ? getBillViaName(group.payment_method.bill_via) : null}}</label>
    </md-table-cell>
    <md-table-cell>
      <div class="flexbox">
        <router-link class="md-button md-raised" tag="md-button" :disabled="deleting"
                     :to="{name: 'BackendUserPaymentMethod', params: {groupId: group.group_id.toString()}}">
          <md-icon>payment</md-icon>
          <span>支払方法確認・変更</span>
        </router-link>
        <router-link v-if="!isTrialUser" class="md-button md-raised" tag="md-button" :disabled="deleting"
                     :to="{name: 'BackendUserDepartmentNew', params: {id: group.group_id.toString()}}">
          <md-icon>edit</md-icon>
          <span>部門名の編集</span>
        </router-link>
        <!-- PHASE3: 部門機能 -->
        <md-button v-if="!isTrialUser && isSuperUser()" v-on:click="deleteConfirm(group)" class="md-button md-raised md-accent"
                   :disabled="deleting">
          <md-icon>delete</md-icon>
          <span>削除</span>
        </md-button>
      </div>
    </md-table-cell>
  </md-table-row>
</template>

<script>
  import CommonMixin from '../../../mixins/commonMixin';

  export default {
    name   : "GroupItem",
    mixins : [CommonMixin],
    props  : {
      group      : {
        type   : Object,
        default: null,
      },
      isTrialUser: {
        type   : Boolean,
        default: true,
      },
      deleting   : {
        type   : Boolean,
        default: false,
      },
    },
    methods: {
      deleteConfirm(group) {
        this.$emit('deleteConfirm', group);
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
